/* eslint-disable max-len */
import { ActiveProject } from './constants';

export const activeProjectRequest = (data) => ({ type: ActiveProject.activeProjectRequest, data });
export const activeProjectSuccess = (data) => ({ type: ActiveProject.activeProjectSuccess, data });
export const activeProjectError = () => ({ type: ActiveProject.activeProjectError });
export const resetProjectData = () => ({ type: ActiveProject.activeProjectReset });
